import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Tooltip from '../Tooltip/Tooltip';

const StyledIconButton = styled.button`
  height: 20px;
  width: 20px;
  background: #fff;
  border: 1px solid #ddd;
  background: #fff;
  border-radius: 1px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  position: relative;

  svg {
    fill: #727272;
    font-size: 14px;
  }

  & + & {
    margin-left: 8px;
  }

  &:hover {
    cursor: pointer;
    border-color: #1890ff;
  }

  &:disabled {
    pointer-events: none;
    opacity: 0.5;
  }
`;

const IconButton = React.forwardRef(
  (
    {
      children,
      disabled,
      onClick,
      tooltip,
      type = 'button',
      ...dataAttributes
    },
    ref,
  ) => {
    const handleClick = (event) => {
      event.stopPropagation();
      onClick(event);
    };

    const renderIconButton = () => (
      <StyledIconButton
        {...dataAttributes}
        disabled={disabled}
        type={type}
        onClick={handleClick}
        ref={ref}
      >
        {children}
      </StyledIconButton>
    );

    if (tooltip) {
      return <Tooltip text={tooltip}>{renderIconButton()}</Tooltip>;
    }

    return renderIconButton();
  },
);

IconButton.propTypes = {
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func.isRequired,
  identifier: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  tooltip: PropTypes.string,
};

export default IconButton;
